import apiClient from '@/services/axios'

export async function post(promoCodeIds) {
  var response = await apiClient.post('/promoCodes/bulk-delete', { 
    promoCodeIds: promoCodeIds 
  })
  
  if (response) {
    return response.data
  }

  throw new Error('Unable to bulk delete Promo Codes.')
}

